<template>
  <div>
    <el-form
      class="el-form searchForm el-form--label-top"
      style="display: flex;"
    >
  <div>
    <el-select v-model="selectvalue" placeholder="請選擇類型" @change="getchange">
              <el-option label="手机号" :value="1"></el-option>
              <el-option label="真实姓名" :value="2"></el-option>
              <el-option label="证件号" :value="3"></el-option>
            </el-select>
            <el-input
              v-model="searchvalue"
              placeholder="请输入搜索条件"
              style="width: 150px;margin-left:10px"
            ></el-input>
  </div>
    </el-form>
    <div class="MenuBtnWrap_right" style="margin-right:16px;margin-bottom:5px">
      <div class="btn" @click="search('search')" style="marginRight:0.2rem">
        查詢
      </div>
      <div class="btn borderBtn" @click="reset()">重置</div>
    
    </div>
    <div class="totalN">
      {{ status == 1 ? `已核銷人數：${total}` : `未核銷人數：${total}` }}
    </div>
    <div class="tableWrap" style="margin-top:0px">
      <el-table height="660px" stripe :data="list" style="width:100%;">
        <template slot="empty">
          <div class="no-data-container">
            <img
              src="@/assets/images/common/no_data.png"
              alt="暂无数据"
              :style="{ width: '244px', height: '139px' }"
            />
          </div>
        </template>
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
              -
            </div>
            <div v-else-if="item.prop === 'areaCode'">
              {{ scope.row.areaCode + " " + scope.row.mobile }}
            </div>
            <div v-else-if="item.prop === 'writeOffTime'">
              {{ $dayjs(scope.row.writeOffTime).format("YYYY-MM-DD HH:mm:ss") }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="status == 0">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="getcheck(scope.row.id, scope.row.username)"
            >
              核銷
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging-block clearfix">
      <el-pagination
        class="paging fr"
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page="page"
        @size-change="handleSizeChange"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="size"
        :pager-count="5"
        layout="sizes, prev, pager, next, jumper "
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import DiaMess from "@/components/dialog";
import dayjs from "dayjs";
export default {
  props: ["activityId", "status",'mode'],
  data() {
    return {
      form: {
        name: "",
        phone: "",
        idCard:""
      },
      searchvalue:'',
      selectvalue:1,
      list: [],
      page: 1,
      size: 20,
      total: 0,
      writeOffCount: "",
      columns:[],
      columnss: [
        {
          prop: "userId",
          label: "会员编号",
          minWidth: "100"
        },
        {
          prop: "username",
          label: "会员账号",
          minWidth: "100"
        },
        {
          prop: "name",
          label: "真实姓名",
          minWidth: "100"
        },
        {
          prop: "mobile",
          label: "手机号码",
          minWidth: "100"
        },
        {
          prop: "writeOffTime",
          label: "核銷時間",
          minWidth: "100"
        },
        {
          prop: "meetingSeatNumber",
          label: "座位號",
          minWidth: "100"
        },
        {
             prop: "remark",
             label: "備注",
             minWidth: "100"
           },
    
      ],
      column: [
        {
          prop: "userId",
          label: "会员编号",
          minWidth: "100"
        },
        {
          prop: "username",
          label: "会员账号",
          minWidth: "100"
        },
        {
          prop: "name",
          label: "真实姓名",
          minWidth: "100"
        },
        {
          prop: "mobile",
          label: "手机号码",
          minWidth: "100"
        },
  
        {
          prop: "meetingSeatNumber",
          label: "座位號",
          minWidth: "100"
        },
        {
             prop: "remark",
             label: "備注",
             minWidth: "100"
           },
    
      ],
      dialogVisible: false
    };
  },
  mounted() {
    this.search();
    if(this.status==0){
      this.columns=this.column
    }else{
      this.columns=this.columnss
    }
  },
  methods: {
    //手動核銷
    getcheck(id, username) {
      let _this = this;
      let params = {
        id,
        activityId: this.activityId
      };
      _this
        .$confirm(`是否核銷${username}用戶?`, "核銷", {
          confirmButtonText: "確定核銷",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          // 确认删除的回调
          _this
            .$post(
              `/write/off/activity/record`,
              params,
              this.$GLOBAL.jsonConfig
            )
            .then(res => {
              if (res.code == "00000") {
                _this.$message({
                  message: "核銷成功",
                  type: "success",
                  center: true,
                  duration: 1000
                });
                _this.search();
              } else {
                _this.$warnMessage(res.message);
              }
            })
            .catch(err => {
              _this.$warnMessage(err);
            });
        })
        .catch(err => {});
    },
    search(type) {
      if (type == "search") {
        this.page = 1;
        this.form.name = "";
        this.form.phone = "";
        this.form.idCard=''
  
        if(this.selectvalue==1){
          this.form.phone=this.searchvalue
        }
        if(this.selectvalue==2){
          this.form.name=this.searchvalue
        }
        if(this.selectvalue==3){
          this.form.idCard=this.searchvalue
      
          
        }
      }
      let url = `/write/off/activity/record/detail?page=${this.page}&size=${this.size}&activityId=${this.activityId}&name=${this.form.name}&status=${this.status}&mobile=${this.form.phone}&mode=${this.mode}&idCard=${this.form.idCard}`;
      this.$get(url).then(res => {
        
        if (res.code == "00000") {
          this.list = res.data.list;
       
          this.total = res.data.total;
          this.writeOffCount = res.data.writeOffCount;
        }
      });
    },
    reset() {
      this.searchvalue='';
 
      this.search("search");
    },
    getchange(e){

    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.size = val;
      this.search();
    }
  },
  components: {
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.MenuBtnWrap_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.totalN {
  text-align: left;
  font-size: 15px;
  color: #91939a;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkActivity/itemList.vue